import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import CSSModules from 'helpers/CSSModulesUtil'
import Highcharts from "highcharts/highstock"

import ThermalCard from './Cards/ThermalCard'
import PexDataEyeCard from './Cards/PexDataEyeCard'
import NvlinkDataEyeCard from './Cards/NvlinkDataEyeCard'
import { Card } from 'react-toolbox/lib/card'
import {
  chartsEnum
} from './constants'
import {
  reportsSelector,
  filtersSelector
} from './selectors'
import styles from './styles.scss'


const mapStateToProps = (state) => {
  return {
    reports: reportsSelector(state),
    filters: filtersSelector(state)
  }
}

class DashboardCard extends Component {
    componentDidUpdate() {
      Highcharts.charts.map(chart => chart ? chart.reflow() : null)
    }
  
  renderReports() {
    const {
      reports,
      filters
    } = this.props

    return(
      <React.Fragment>
        {filters.includes(chartsEnum.THERMAL_TDP_GPU_TEMP.value) &&
        <Card styleName='chartContainer' key={1}>
         <ThermalCard report={reports.find(r => r.type == chartsEnum.THERMAL_TDP_GPU_TEMP.value)} />
        </Card>}
        {filters.includes(chartsEnum.THERMAL_TDP_MEM_TEMP.value) &&
        <Card styleName='chartContainer' key={2}>
         <ThermalCard report={reports.find(r => r.type == chartsEnum.THERMAL_TDP_MEM_TEMP.value)} />
         </Card>}
        {filters.includes(chartsEnum.THERMAL_TDP_GPU_POWER.value) &&
        <Card styleName='chartContainer' key={3}>
         <ThermalCard report={reports.find(r => r.type == chartsEnum.THERMAL_TDP_GPU_POWER.value)} />
         </Card>}
        {filters.includes(chartsEnum.THERMAL_TDP_MAX_GPU_TEMP.value) &&
        <Card styleName='chartContainer' key={4}>
         <ThermalCard report={reports.find(r => r.type == chartsEnum.THERMAL_TDP_MAX_GPU_TEMP.value)} />
         </Card>}
        {filters.includes(chartsEnum.THERMAL_TDP_MAX_MEM_TEMP.value) &&
        <Card styleName='chartContainer' key={5}>
         <ThermalCard report={reports.find(r => r.type == chartsEnum.THERMAL_TDP_MAX_MEM_TEMP.value)} />
         </Card>}
        {filters.includes(chartsEnum.THERMAL_TDP_MAX_GPU_POWER.value) &&
          <Card styleName='chartContainer' key={6}>
         <ThermalCard report={reports.find(r => r.type == chartsEnum.THERMAL_TDP_MAX_GPU_POWER.value)} />
         </Card>}
         {filters.includes(chartsEnum.NVLINK_DATA_EYE_Y.value) &&
          <Card styleName='chartContainer' key={7}>
         <NvlinkDataEyeCard report={reports.find(r => r.type == chartsEnum.NVLINK_DATA_EYE_Y.value)} />
         </Card>}
         {filters.includes(chartsEnum.NVLINK_DATA_EYE_X.value) &&
          <Card styleName='chartContainer' key={8}>
         <NvlinkDataEyeCard report={reports.find(r => r.type == chartsEnum.NVLINK_DATA_EYE_X.value)} />
         </Card>}
        {filters.includes(chartsEnum.PEX_DATA_EYE_Y.value) &&
          <Card styleName='chartContainer' key={9}>
         <PexDataEyeCard report={reports.find(r => r.type == chartsEnum.PEX_DATA_EYE_Y.value)} />
         </Card>}
        {filters.includes(chartsEnum.PEX_DATA_EYE_X.value) &&
          <Card styleName='chartContainer' key={10}>
          <PexDataEyeCard report={reports.find(r => r.type == chartsEnum.PEX_DATA_EYE_X.value)} />
         </Card>}
      </React.Fragment>
    )
  }

  render() {
    return (
      <div styleName='chartsContainer'>
        { this.renderReports() }
      </div>
    )
  }
}

const withConnect = connect(mapStateToProps, null)
const withStyle = CSSModules(styles)

export default compose(
  withConnect,
  withStyle
)(DashboardCard)
